import axios from 'axios';

const otpApi = axios.create({
  baseURL: process.env.VUE_APP_API_ORDER,
  headers: {
    'X-API-KEY': process.env.VUE_APP_API_KEY,
  },
});

export default otpApi;
